import {
  GridRenderCellParams,
  GridRenderEditCellParams,
  GridValidRowModel,
} from '@mui/x-data-grid-pro';
import { useMemo } from 'react';

import { CellParams, ColumnDef } from './types';

export function useColumnsWithCellState<TRow extends GridValidRowModel, CellState, TColumnData>(
  columns: ColumnDef<TRow, CellState, TColumnData>[],
  getCellState: (cellId: string) => CellState | undefined,
) {
  return useMemo(() => {
    return columns.map((column) => ({
      ...column,
      renderCell: (params: GridRenderCellParams<TRow>) => {
        const cellId = `${params.row.id}_${params.field}`;

        const cellParams: CellParams<TRow, CellState> = {
          row: params.row,
          field: params.field,
          value: params.value,
          cellState: getCellState?.(cellId),
        };
        return column.renderCell(cellParams);
      },
      renderEditCell: column.renderEditCell
        ? (params: GridRenderEditCellParams<TRow>) => {
            const cellParams: CellParams<TRow, CellState> = {
              row: params.row,
              field: params.field,
              value: params.value,
              cellState: getCellState?.(`${params.row.id}_${params.field}`),
            };
            return column.renderEditCell?.(cellParams);
          }
        : undefined,
    }));
  }, [columns, getCellState]);
}
